export default "__VITE_ASSET__a461148f__"